import './styles.css';

import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';

import type { IBaseCall, IBaseProps, Result } from 'bz-core-controls/modal-new/confirmation';

import ClickDialog from 'click-controls/controls/dialog';
import Button from 'click-controls/controls/form/button';
import React from 'react';
import ErrorPanel from '../error-panel';

export interface IErrorCall extends IBaseCall {}

export interface IErrorDialogProps extends IBaseProps {}

export type ErrorResult = Result.yes | Result.cancel;

class ErrorDialog extends React.Component<IErrorDialogProps> {
  render() {
    const { className, hasErrors } = this;
    const {
      contents,
      contentProps,
      dialogProps,
      errors,
      errorsTitle,
      open,
      title,
      titleProps,
      onErrorsOk,
      onErrorsCancel
    } = this.props;

    let errorPanel;
    if (hasErrors) {
      errorPanel = (
        <ErrorPanel
          className={this.props.className}
          errors={errors as string[]}
          title={errorsTitle}
          onOk={onErrorsOk}
          onCancel={onErrorsCancel}
        />
      );
    }
    if (!!process.env.isClick) {
      return (
        <ClickDialog
          containerClass={`max-h-full ${className}`}
          bodyClass="max-h-96 overflow-y-auto"
          width="1/3 xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-1/2"
          isOpen={open}
          title={title}
          centered={true}
          footer={
            <div className={'flex flex-wrap justify-end gap-3 px-6 pt-6 pb-2'}>
              <Button onPress={onErrorsOk} className={'btn'}>
                Yes
              </Button>
              <Button className={'btn'} onPress={onErrorsCancel}>
                No
              </Button>
            </div>
          }
        >
          {contents}
          {errorPanel}
        </ClickDialog>
      );
    }
    return (
      <Dialog
        {...dialogProps}
        className={`${className} dialog`}
        classes={{ container: `${className} !items-center justify-center` }}
        open={open}
      >
        <DialogTitle {...titleProps} className={`${className} title`}>
          {title}
        </DialogTitle>
        <DialogContent {...contentProps} className={`${className} content`}>
          {contents}
          {errorPanel}
        </DialogContent>
      </Dialog>
    );
  }

  private get className(): string {
    const { className } = this.props;
    const classNames = ['bz-controls bz-modal error-dialog'];

    if (!!className) {
      classNames.push(className);
    }

    return classNames.join(' ');
  }

  private get hasErrors(): boolean {
    const { errors } = this.props;

    return !!errors && errors.length > 0;
  }
}

export default ErrorDialog;
